<template>
  <Chip :color="color" text-color="white" un-clickable>{{label}}</Chip>
</template>

<script>
import Chip from "../atoms/Chip";
export default {
  name: "ApplicationTypeChip",
  components: {Chip},
  props: {
    viaRequest: {
      type: Boolean
    },
    requestByProxy: {
      type: Boolean
    },
  },
  computed: {
    color() {
      if (this.viaRequest) {
        return "requestApplication"
      }
      return "selfApplication"
    },
    label() {
      return this.viaRequest
        ? (this.requestByProxy ? "★スカウト代行" : "スカウト")
        : "自己応募";
    }
  }
}
</script>

<style scoped>

</style>